import Vue from 'vue'
import moment from 'moment'

Vue.filter('formatDatetime', function(value, format) {
  if (format) {
    return moment(value).format(format)
  }
  return moment(value).format(window._$t('common.format.datetime'))
})

Vue.filter('formatDate', function(value, format) {
  if (format) {
    return moment(value).format(format)
  }
  return moment(value).format(window._$t('common.format.date'))
})

Vue.filter('formatInhabitantsIdentificationNumber', function(value) {
  if (!value) {
    return ''
  }
  let val
  value = value + ''
  val = value.replace(new RegExp('-', 'g'), '')
  if (val && (val.length !== 13 || isNaN(val))) {
    return value
  }
  val = val.substring(0, 6) + '-' + val.substring(6, 13)
  return val
})

Vue.filter('formatCardNo', function(value) {
  if (!value) {
    return ''
  }
  let val
  value = value + ''
  val = value.replace(new RegExp('-', 'g'), '')
  if (val && (val.length !== 12 || isNaN(val))) {
    return value
  }
  val =
    val.substring(0, 4) + '-' + val.substring(4, 8) + '-' + val.substring(8, 12)
  return val
})

Vue.filter('formatJuridicalRegistrationNumber', function(value) {
  if (!value) {
    return ''
  }
  let val
  value = value + ''
  val = value.replace(new RegExp('-', 'g'), '')
  if (val && (val.length !== 13 || isNaN(val))) {
    return value
  }
  val = val.substring(0, 6) + '-' + val.substring(6, 13)
  return val
})

Vue.filter('formatBusinessRegistrationNumber', function(value) {
  if (!value) {
    return ''
  }
  value = value + ''
  const val = value.replace(new RegExp('-', 'g'), '')
  if (val && (val.length !== 10 || isNaN(val))) {
    return value
  }
  return (
    val.substring(0, 3) + '-' + val.substring(3, 5) + '-' + val.substring(5, 10)
  )
})

Vue.filter('formatTimeHumanFriendly', function(value) {
  const milliSeconds = new Date() - value
  const seconds = milliSeconds / 1000
  if (seconds < 60) return window._$t('time.text.just_now')
  const minutes = seconds / 60
  if (minutes < 60)
    return window._$t('time.text.minutes_ago', { minutes: Math.floor(minutes) })
  const hours = minutes / 60
  if (hours < 24)
    return window._$t('time.text.hours_ago', { hours: Math.floor(hours) })
  const days = hours / 24
  if (days < 7)
    return window._$t('time.text.days_ago', { days: Math.floor(days) })
  const weeks = days / 7
  if (weeks < 5)
    return window._$t('time.text.weeks_ago', { weeks: Math.floor(weeks) })
  const months = days / 30
  if (months < 12)
    return window._$t('time.text.months_ago', { months: Math.floor(months) })
  const years = days / 365
  return window._$t('time.text.years_ago', { years: Math.floor(years) })
})

Vue.filter('formatKoreanTel', function(value, masking) {
  if (!value) {
    return ''
  }
  let val
  value = value + ''
  val = value.replace(new RegExp('-', 'g'), '')
  if (val && val.length === 7 && !val.startsWith('0')) {
    val = val.substring(0, 3) + '-' + val.substring(3)
  } else if (val && val.length === 8 && !val.startsWith('0')) {
    val = val.substring(0, 4) + '-' + val.substring(4)
  } else if (
    val &&
    (val.length === 10 || val.length === 11) &&
    val.startsWith('01')
  ) {
    // 휴대폰 번호
    if (val.length === 10) {
      val =
        val.substring(0, 3) + '-' + val.substring(3, 6) + '-' + val.substring(6)
    } else {
      val =
        val.substring(0, 3) + '-' + val.substring(3, 7) + '-' + val.substring(7)
    }
  } else if (
    val &&
    val.length >= 9 &&
    val.length <= 10 &&
    val.startsWith('02')
  ) {
    // 서울 일반 전화번호
    if (val.length === 9) {
      val =
        val.substring(0, 2) + '-' + val.substring(2, 5) + '-' + val.substring(5)
    } else {
      val =
        val.substring(0, 2) + '-' + val.substring(2, 6) + '-' + val.substring(6)
    }
  } else if (
    val &&
    val.length >= 10 &&
    val.length <= 11 &&
    !val.startsWith('02')
  ) {
    // 서울 외 일반 전화번호
    if (val.length === 10) {
      val =
        val.substring(0, 3) + '-' + val.substring(3, 6) + '-' + val.substring(6)
    } else {
      val =
        val.substring(0, 3) + '-' + val.substring(3, 7) + '-' + val.substring(7)
    }
  } else {
    val = value
  }
  if (masking && val.length > 4) {
    val = val.substring(0, val.length - 4) + '****'
  }
  return val
})

Vue.filter('formatTimeFromSeconds', function(value) {
  if (!value) return '0:00:00'
  const hours = Math.floor(value / 60 / 60)
  let minutes = Math.floor(value / 60) % 60
  if (minutes < 10) {
    minutes = '0' + minutes
  }
  let seconds = value % 60
  if (seconds < 10) {
    seconds = '0' + seconds
  }
  return hours + ':' + minutes + ':' + seconds
})

Vue.filter('formatNumber', function(value, defaultValue) {
  if (value === 0) return '0'
  if (!value) {
    if (defaultValue !== undefined) {
      return defaultValue
    }
    return ''
  }
  return value.toFixed(0).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, '$1,')
})

Vue.filter('currency', function(value, currency) {
  let locale
  if (window.navigator.languages) {
    locale = window.navigator.languages[0]
  } else {
    locale = window.navigator.userLanguage || window.navigator.language
  }
  if (!locale) {
    locale = 'ko-kr'
  }
  if (!currency) {
    currency = 'KRW'
  }
  if (isNaN(value)) {
    value = 0
  }
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 0
  }).format(value)
})

Vue.filter('point', function(value, symbol, position) {
  let locale
  if (window.navigator.languages) {
    locale = window.navigator.languages[0]
  } else {
    locale = window.navigator.userLanguage || window.navigator.language
  }
  if (!locale) {
    locale = 'ko-kr'
  }
  let ret = ''
  if (position === 'prefix') {
    ret += symbol
  }
  ret += new Intl.NumberFormat(locale, {
    style: 'decimal',
    minimumFractionDigits: 0
  }).format(value)
  if (position === 'suffix') {
    ret += symbol
  }
  return ret
})
